import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { motion } from 'framer-motion';

export const PageHeader = ({ title, subtitle, breadcrumbs }) => {
  return (
    <div
      className="relative min-h-[50vh] flex items-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `url('/images/breadcrumb/01.png')`,
      }}
    >
      <div className="container-custom relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center text-primary-foreground"
        >
          {/* Breadcrumbs */}
          {breadcrumbs && (
            <div className="flex items-center justify-center space-x-2 text-sm mb-6">
              {breadcrumbs.map((crumb, index) => (
                <React.Fragment key={index}>
                  {index > 0 && <ChevronRight className="h-4 w-4 opacity-60" />}
                  {crumb.path ? (
                    <Link
                      to={crumb.path}
                      className="hover:text-accent-gold transition-colors opacity-80 hover:opacity-100"
                    >
                      {crumb.label}
                    </Link>
                  ) : (
                    <span className="text-accent-gold">{crumb.label}</span>
                  )}
                </React.Fragment>
              ))}
            </div>
          )}

          {/* Title */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-bold mb-6">
            {title}
          </h1>

          {/* Subtitle */}
          {subtitle && (
            <p className="text-lg sm:text-xl text-primary-foreground/90 max-w-3xl mx-auto leading-relaxed">
              {subtitle}
            </p>
          )}
        </motion.div>
      </div>
    </div>
  );
};
